/**
 * @author Leonel Martinez
 * @module Snackbar
 * @fileoverview `Vuex snackbar module`
 * @see Snackbar.vue
 */

const getDefaultState = () => {
  return {
    isActive: false,
    color: "primary",
    icon: '',
    iconColor: 'white',
    text: "Default message",
    multiline: false,
    timeout: 6000,
    x: "right",
    y: "bottom",
    hasAction: false,
    action: () => {},
    actionText: 'OK'
  }
};

export const snackbar = {
  namespaced: true,
  state: {
    isActive: false,
    color: "primary",
    icon: '',
    iconColor: 'white',
    text: "Default message",
    multiline: false,
    timeout: 6000,
    x: "right",
    y: "bottom",
    hasAction: false,
    action: () => {},
    actionText: 'OK'
  },
  actions: {
    /**
     * @param {object} options Object collection with all or some state properties
     */
    SHOW_SNACKBAR({ commit }, options) {
      commit("SHOW_SNACKBAR", options);
    },
    HIDE_SNACKBAR({ commit }) {
      commit("HIDE_SNACKBAR");
    }
  },
  mutations: {
    SHOW_SNACKBAR(state, options) {
      state.isActive = true;
      state.color = options.color || state.color;
      state.text = options.text || state.text;
      state.icon = options.icon || state.icon;
      state.iconColor = options.iconColor || state.iconColor;
      state.multiline = options.multiline || state.multiline;
      state.timeout = options.timeout || state.timeout;
      state.x = options.x || state.x;
      state.y = options.y || state.y;
      state.hasAction = options.hasAction || state.hasAction;
      state.actionText = options.actionText || state.actionText;
      state.action = options.action || state.action;
    },
    HIDE_SNACKBAR(state) {
       // Reset Snackbar state to set default properties
      Object.assign(state, getDefaultState());
    }
  }
};
